import { liveAwsConfig } from "./aws/aws-exports.live"

export const productionEnvironmentConfig = {
	baseUrl: liveAwsConfig.aws_appsync_graphqlEndpoint,
	serverUrl: 'https://api.cleantagger.com/',
	stripeApiKey: 'pk_test_51GrMtqGOI0VtIqckvPP9mWmRg76ic42W5f4JQ2F4V252HEY44PRDqdghUChO7yXd9azpCC1KDxcBlKvs2L3EOFxD00byXfjq3I',
	paymentApi: 'https://7w62v4j1o9.execute-api.us-east-2.amazonaws.com/dev/',
}